import Script from 'next/script';

const JsonLD = function ({ data }) {
  return (
    <Script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
  );
};

export default JsonLD;
